<div class="form-group">
    <label class="control-label" ng-if="!edit.domainWachau">{{'PARCELS_PARAM_WINELOCATION' | translate}}</label>
    <label class="control-label" ng-if="edit.domainWachau">Riede</label>
    <input class="form-control"
               type="text"
               ng-maxlength="255"
               ng-readonly="!edit.fullEditAvailable || edit.isShared"
               ng-model="edit.item.wineLocation" />
    <p class="help-block"
       ng-messages="form.wineLocation.$error">
        <span ng-message="maxlength">{{('FORM_HELP_MAXLENGTH' | translate:{max: 255})}}</span>
    </p>
</div>
